module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/edit-small-1be9d6ddbb5488ba49225c8e68ad41fb.svg";